/**
 * @file programParticipation.js
 * @author Jake Stark
 * @desc Program Participation report

*/

/**
 * @module programParticipation
 * @desc Program Participation report
 */

define('plugins/programParticipation',[
  "underscore",
  "models",
  "cardboard/models",
  "cardboard/collections",
  "cardboard/util",
  "cardboard/pluginPieces",
  "text!plugins/templates/programParticipation_eec_table.html!strip",
  "text!plugins/templates/programParticipation_eecByYear_table.html!strip",
  "text!plugins/templates/programParticipation_famSupp_table.html!strip",
  "text!plugins/templates/programParticipation_famSuppByEec_table.html!strip",
], function (
  _,
  ECLDSModels,
  CardboardModels,
  CardboardCollections,
  Util,
  PluginPieces,
  eecTemplate,
  eecByYearTemplate,
  famSuppTemplate
) {
  console.log("MODULE: programParticipation");
  //  var colors = Highcharts.getOptions().colors;
  var colors = [
    Util.Color.gradients.blue1,
    Util.Color.gradients.green,
    Util.Color.gradients.blue2,
    Util.Color.gradients.grey2,
    Util.Color.gradients.purple,
    Util.Color.gradients.gold,
    Util.Color.gradients.blue3,
    Util.Color.gradients.cream,
  ];

  var tableClone, chartHeadClone;

  var $input = [];
  var tId, hc, nId, chartHeadId;
  window.appECLDS = "true";
  var url;

  drill = function (options, chartId, event) {
    var myChart, myChartIndex;

    var tableCount = 0,
      chartHeads = 0,
      notes = 0;
      options = options.replace("|", "%7c")
    
    if (location.hash.indexOf("deafHardOfHearing") > -1) {
      url =
        "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_sec_o_deafHardOfHearingProgram_drill" +
        options;
    } else {
      url =
        "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_programParticipation_drilleec" +
        options;
    }
    $.getJSON(url, function (json) {
      var chartData = [];

      if (json.dataSets) {
        $.each($(".eec"), function (index, value) {
          this.setAttribute("id", "" + tableCount + "");
          ++tableCount;
        });

        $.each($(".chartHead"), function (index, value) {
          this.setAttribute("id", "ch" + chartHeads + "");
          ++chartHeads;
        });

        $.each($(".noteChart"), function (index, value) {
          this.setAttribute("id", "note" + notes + "");
          ++notes;
        });

        if (chartId) {
          hc = "#" + chartId + "";
          for (i = 0; i < charts.length; i++) {
            if (charts[i].container.id == chartId) myChart = i;
          }
        } else {
          chartId =
            event.target.parentElement.parentElement.parentElement.parentElement
              .parentElement.parentElement.previousElementSibling.firstChild.id;
          for (i = 0; i < charts.length; i++) {
            if (charts[i].container.id == chartId) myChart = i;
          }
          hc = "#" + charts[myChart].container.id + "";
        }

        charts[myChart].myChartTableId =
          charts[myChart].container.parentElement.nextSibling.firstChild.id;
        if (location.hash.indexOf("deafHardOfHearing") > -1) {
          charts[myChart].myChartHeadId =
            charts[
              myChart
            ].container.parentElement.previousSibling.firstChild.id;
        } else {
          charts[myChart].myChartHeadId =
            charts[
              myChart
            ].container.parentElement.previousSibling.previousSibling.firstChild.id;
        }

        tId = "#" + charts[myChart].myChartTableId + "";
        nId = "#note" + charts[myChart].myChartTableId + "";
        chartHeadId = "#" + charts[myChart].myChartHeadId + "";

        tableSave[charts[myChart].myChartTableId] =
          "<table id=" + charts[myChart].myChartTableId + " class='eec'>";

        chartHeadSave[charts[myChart].myChartTableId] =
          "<h5 id=" +
          charts[myChart].myChartHeadId +
          " class='chartHead'>" +
          $(chartHeadId)[0].innerHTML +
          "</h5>";

        for (i = 0; i < charts[myChart].series[0].data.length; i++)
          chartSave[i] = jQuery.extend(
            true,
            {},
            charts[myChart].series[0].data[i]
          );

        while (charts[myChart].series.length > 0)
          charts[myChart].series[0].remove();
        var data;

        if (location.hash.indexOf("deafHardOfHearing") > -1) {
          data = json.dataSets.dhhDrill.data;
        } else {
          data = json.dataSets.earlyEducationAndCare.data;
        }
        var tableContent =
          '<table id="' +
          charts[myChart].myChartTableId +
          '" class="eec"><thead><th>Program Combinations</th><th>Participation</th></thead>';

        charts[myChart].options.plotOptions.column.colorByPoint = false;
        charts[myChart].xAxis[0].update({
          labels: {
            enabled: false,
          },
        });
        charts[myChart].yAxis[0].update({
          max: 100,
        });
        charts[myChart].legend.options.enabled = true;

        for (i = 0; i < data.length; i++) {
          chartData = [];
          chartData.push([data[i]["programName"], data[i]["percent"]]);
          tableContent +=
            "<tr><th>" +
            data[i]["programName"] +
            "</th><td>" +
            data[i]["formattedCount"] +
            " " +
            data[i]["formattedPercent"] +
            "</td></tr>";
          charts[myChart].addSeries(
            {
              stacking: "normal",
              name: data[i]["programName"],
              data: chartData,
              color: colors[i],
              dataLabels: false,
            },
            false
          );
        }

        tableContent += "</table>";

        tableClone = $(tId).clone();

        tableSave[charts[myChart].myChartTableId] +=
          tableClone[0].innerHTML + "</table>";

        $(tId).replaceWith(tableContent);
        $(nId).replaceWith(
          "<div id=note" +
            charts[myChart].myChartTableId +
            "><p>NOTE: Click on Back button to return to previous chart. </p> <button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>"
        );
        tableClone = $(tId).clone();

        var myChartString = "'" + myChart + "'";

        var button =
          '<input type="button" value="Back" class="backButton" id="backButton' +
          charts[myChart].myChartTableId +
          '" onclick="restoreEecReport(' +
          charts[myChart].chartId +
          ');"/>';

        $input[myChart] = $(button);
        $input[myChart].appendTo(hc);

        chartHeadClone = $(chartHeadId).clone();
        if (location.hash.indexOf("deafHardOfHearing") > -1) {
          $(chartHeadId).replaceWith(
            "<h5 id='" +
              charts[myChart].myChartHeadId +
              "' class='chartHead'>" +
              json.dataSets.dhhDrill.heading +
              "</h5>"
          );
        } else {
          $(chartHeadId).replaceWith(
            "<h5 id='" +
              charts[myChart].myChartHeadId +
              "' class='chartHead'>" +
              json.dataSets.earlyEducationAndCare.heading +
              "</h5>"
          );
        }
        charts[myChart].render();
      } else {
        alert(json.meta.dataNotAvailableMessage);
      }
    });
  };

  $("#progData").click(function () {
    window.workspace.setModalInfoDialogContent(
      "  <p><strong>Child Care Assistance Program</strong>: (CCAP) helps make quality child care affordable by providing financial assistance to help families with low incomes pay for child care. <br/><a href='http://mn.gov/dhs/people-we-serve/children-and-families/economic-assistance/child-care/index.jsp' target='_blank'>Child Care Assistance Program  </a> </p>            <p><b>Early Childhood Family Education</b>: (ECFE) provides supports for all Minnesota families with children between the ages of birth to kindergarten entrance based on the idea that parents are a child's first and most important teachers. <a href='https://education.mn.gov/MDE/StuSuc/EarlyLearn/ECFE/index.html' target='_blank'>Early Childhood Family Education </a></p>                            <p><b>Early Childhood Special Education</b>: (ECSE) provides supports and services to infants, toddlers and preschool children with disabilities and their families.<br/>  <a href='https://education.mn.gov/MDE/EdExc/EarlyChildRes/EarlyChildSpecEd/index.html' target='_blank'>Early Childhood Special Education  </a></p>          <p><b>MN District Preschool</b>: program for children age three to kindergarten entrance with the purpose of preparing children to enter kindergarten. <br/><a href='https://education.mn.gov/MDE/SchSup/DataSubLogin/EarlyEducStudent/index.html' target='_blank'> Early Education Student </a> </p><p>                                        ECLDS charts start with Kindergarten cohorts and look back at previous program participation. As seen on the <a href='/#data' target='_blank'>Data Source Matrix</a>, Early Education Student is starting in the ECLDS with SFY14 cohort for ECFE and District Preschool. Kindergarten data is finalized the January following the end of the school year. June 2016 will be the first time that the SFY14 information for ECFE and District Preschool will be available in kindergarten cohort charts. June 2020 is the anticipated first time for a kindergartner's birth to five participation in ECFE and District Preschool (EE Student 17-18 cohort) will be reflected in kindergarten cohort information.   </p> "
    );
    Backbone.trigger("modalOpened");
    window.workspace.showModalInfoDialog();
  });

  restoreEecReport = function (myChartString) {
    var myChart = parseInt(myChartString);

    for (i = 0; i < charts.length; i++) {
      if (charts[i].chartId == myChart) myChart = i;
    }

    var data = [];
    tId = "#" + charts[myChart].myChartTableId + "";
    nId = "#note" + charts[myChart].myChartTableId + "";

    chartHeadId = "#" + charts[myChart].myChartHeadId + "";

    $(nId).replaceWith(
      "<div class='noteChart'><p>NOTE: Click on a program to see multiple program participation counts.</p><p>NOTE: Because ECFE serves children from birth to Kindergarten entrance, and ECFE data begins with the 2013-14 school year, ECLDS most fully represents ECFE participation in Kindergarten reports beginning with the 2019-20 school year.</p> <button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>"
    );

    $(tId).replaceWith(tableSave[charts[myChart].myChartTableId]);
    $(chartHeadId).replaceWith(chartHeadSave[charts[myChart].myChartTableId]);
    $input[myChart].remove();

    for (i = 0; i < chartSave.length; i++) {
      data.push({
        name: chartSave[i]["name"],
        y: chartSave[i]["y"],
        x: chartSave[i]["x"],
        color: chartSave[i]["color"],
        allInfo: {
          drillParm: chartSave[i]["allInfo"]["drillParm"],
        },
      });
    }

    while (charts[myChart].series.length > 0)
      charts[myChart].series[0].remove();

    charts[myChart].legend.options.enabled = false;
    charts[myChart].yAxis[0].update({
      max: 50,
    });
    charts[myChart].xAxis[0].update({
      labels: {
        enabled: true,
      },
    });
    charts[myChart].addSeries(
      {
        type: "column",
        data: data,
        color: chartSave.colors,
        dataLabels: false,
      },
      false
    );
    charts[myChart].render();
  };

  var exports = {
    // options for the demo cats config. since this is a multi-select
    // report, we have to use a different view object, and tell it not to
    // show grades as categories.
    options: {
      orgDetailPane: false,
      noMapSearch: true,
      noOrgSearch: false,
      noOrgFinderSchool: true,
      orgFinderDistrict: true,
      forcedSummaryFilters: ["FISCAL_YEAR"],
      definitionsECLDS: true,
    },

    // each of these is the configuration that gets passed to a
    // DataBoxPaneView.
    panes: [
      {
        title: "Participation in Public Early Care and Education",
        explanationText:
          "<p>This chart shows public school kindergartners who participated in at least one of the following public early care and education programs: Child Care Assistance (CCAP), Early Childhood Family Education (ECFE), Early Childhood Special Education (ECSE) or School District Preschool (MN District Preschool) prior to kindergarten entry. More information about the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=MDE034819&RevisionSelectionMethod=latestReleased&Rendition=primary' class='progData' target='_blank'>public programs included in ECLDS</a> is available.</p><p> Not all children participating in these programs may have attended public kindergarten in Minnesota. Many children attend private child care and early learning programs prior to kindergarten and are not included in these counts. </p> ",
        openByDefault: true,

        views: [
          {
            type: "template",
            template: "<h5 class='chartHead'>{{data.heading}}</h5>",
            dataSourceName: "data",
            dataPath: "dataSets.earlyEducationAndCareParticipation",
          },
          {
            type: "template",
            template:
              "<p>NOTE: Because ECFE serves children from birth to Kindergarten entrance, and ECFE data begins with the 2013-14 school year, ECLDS most fully represents ECFE participation in Kindergarten reports beginning with the 2019-20 school year.</p> <button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.children[0].id);'>Export to PDF</button>",
          },
          {
            // SETUP
            type: "pie",
            dataSourceName: "data",
            dataSetPath: "dataSets.earlyEducationAndCareParticipation",

            //dataPath: "dataSets.raceAndEthnicity.data",
            // all paths in the
            // chartable series are
            // relative to this blob

            // "pointsWithinRows": given that the data is
            // two-dimensional (meaning an array of arrays, or
            // similar structure, implying that we have more than
            // one series to plot) each series is contained in a
            // "row", like so:
            //	 +---------+
            //	 | X X X X |
            //	 | . . . . |
            //	 | . . . . |
            //	 | . . . . |
            //	 +---------+
            dataShape: "pointsWithinRows",

            // since in this case there's only one dimension, due to
            // there being only one series to plot, it looks like
            // this:
            //	 +---------+
            //	 | X X X X |
            //	 +---------+
            convertDataHashToArray: true,
            dataDimensions: 1,
            title: "",

            // DISPLAY
            unitString: "%",
            showLegend: true,
            dataLabels: false,
            unitDec: 1,
            disableLegendClick: false,
            exportToPDF: true,
            hideContext: true,

            // SERIES (only one series, this is a simple graph)
            series: [
              {
                valuePath: "percent",
                displayNamePath: "programName",
                longDisplayNamePath: "programName",
              },
            ],
            errorConditions: [PluginPieces.standardErrorCondition],
          },

          {
            type: "template",
            dataSourceName: "data",
            dataSetPath: "dataSets.earlyEducationAndCareParticipation",
            template: famSuppTemplate,
            errorConditions: [PluginPieces.silentStandardErrorCondition],
          },
        ],
      },
      {
        title: "Participation by Program",
        explanationText:
          "<p>This chart shows public school kindergartners who participated in at least one of the following public early care and education programs: Child Care Assistance (CCAP), Early Childhood Family Education (ECFE), Early Childhood Special Education (ECSE) or School District Preschool (MN District Preschool) prior to kindergarten entry. Some children participated in more than one program. More information about the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=MDE034819&RevisionSelectionMethod=latestReleased&Rendition=primary' target='_blank'>public programs included in ECLDS</a> is available. </p><p>Not all children participating in these programs may have attended public kindergarten in Minnesota. Many children attend private child care and early learning programs prior to kindergarten and are not included in these counts.</p> ",
        openByDefault: false,
        views: [
          {
            type: "template",
            template: "<h5 class='chartHead'>{{data.heading}}</h5>",
            dataSourceName: "data",
            dataPath: "dataSets.earlyEducationAndCare",
          },
          {
            type: "template",
            template:
              "<div class='noteChart'><p>NOTE: Click on a program to see multiple program participation counts.</p> <p>NOTE: Because ECFE serves children from birth to Kindergarten entrance, and ECFE data begins with the 2013-14 school year, ECLDS most fully represents ECFE participation in Kindergarten reports beginning with the 2019-20 school year.</p><button style='float:right;' onclick='exportChart(this.parentNode.parentNode.nextSibling.children[0].id);'>Export to PDF</button></div>",
          },
          {
            // SETUP
            // one glob = one line series
            // in each series, one row = one data point
            type: "column",
            dataSourceName: "data",
            dataSetPath: "dataSets.earlyEducationAndCare",
            yAxisMax: 60,
            title: "",

            // "pointsWithinRows": given that the data is
            // two-dimensional (meaning an array of arrays, or
            // similar structure, implying that we have more than
            // one series to plot) each series is contained in a
            // "row", like so:
            //	 +---------+
            //	 | X X X X |
            //	 | . . . . |
            //	 | . . . . |
            //	 | . . . . |
            //	 +---------+
            dataShape: "pointsWithinRows",
            dataDimensions: 1,

            // DISPLAY
            // xAxisLabelPath: "label",
            unitString: "%",
            showLegend: false,
            colorByPoint: true,
            unitDec: 1,
            disableLegendClick: false,
            exportToPDF: true,
            hideContext: true,

            // SERIES
            series: [
              {
                seriesDisplayNamePath: "programName",
                // seriesDisplayName: "programName",
                dataPath: "",
                valuePath: "percent",
                displayNamePath: "programName",
                //  colors: ["orange", "purple", "green", "blue1"],
              },
            ],
            errorConditions: [PluginPieces.standardErrorCondition],
          },
          {
            type: "template",
            template: eecTemplate,
            dataSourceName: "data",
            dataSetPath: "dataSets.earlyEducationAndCare",
            errorConditions: [PluginPieces.silentStandardErrorCondition],
          },
        ],
      },
      {
        title: "Participation by Year Prior to Kindergarten",
        visibleByDefault: true,
        openByDefault: false,
        explanationText:
          "<p>This chart shows the public school kindergartners who participated in some public early care and education programs each year prior to kindergarten entry. Children are counted once for each year by program but may participate in more than one program or in one program during multiple years. In this chart, children one and two years prior to kindergarten were likely between the ages of 3-5 years old. Children three or more years prior to kindergarten were likely birth to 3 years old.  </p><p> Many children attend private child care and early learning programs prior to kindergarten and are not included in these counts.  </p><p></p> ",
        views: [
          {
            type: "template",
            template: "<h5>{{data.heading}}</h5>",
            dataSourceName: "data",
            dataPath: "dataSets.earlyEducationAndCareByYear",
          },
          {
            type: "template",
            template:
              "<p>NOTE: This chart shows the kindergartners who participated in public early care and education programs each year prior to entering kindergarten. Some children participate in a program over multiple years. Some children participate in multiple programs within a year.</p> <p>NOTE: Because ECFE serves children from birth to Kindergarten entrance, and ECFE data begins with the 2013-14 school year, ECLDS most fully represents ECFE participation in Kindergarten reports beginning with the 2019-20 school year.</p><button style='float:right;' onclick='exportChart(this.parentNode.nextSibling.children[0].id);'>Export to PDF</button>",
          },

          {
            // SETUP
            // all globs go into one series
            // each glob has only one row = one data point
            type: "column",
            dataSourceName: "data",
            dataSetPath: "dataSets.earlyEducationAndCareByYear",
            convertDataHashToArray: true,
            yAxisMax: 60,
            title: "",

            // "pointsWithinRows": given that the data is
            // two-dimensional (meaning an array of arrays, or
            // similar structure, implying that we have more than
            // one series to plot) each series is contained in a
            // "row", like so:
            //	 +---------+
            //	 | X X X X |
            //	 | . . . . |
            //	 | . . . . |
            //	 | . . . . |
            //	 +---------+
            dataShape: "pointsAcrossRows",

            // since in this case there's only one dimension, due to
            // there being only one series to plot, it looks like
            // this:
            //	 +---------+
            //	 | X X X X |
            //	 +---------+
            dataDimensions: 2,

            // DISPLAY
            // categoryFieldName: "entityType",
            unitString: "%",
            unitDec: 1,
            disableLegendClick: false,
            exportToPDF: true,
            hideContext: true,
            xAxisLabelPath: "periodName",
            //  tooltipTemplate: "{{programName}}<br /><br />" + "<b>{{formattedPercent}} </b><br />",
            //  colorByPoint: false,
            showLegend: true,

            // SERIES
            series: [
              {
                valuePath: "programName[0].percent",
                seriesDisplayName: "Child Care Assistance Program (CCAP)",
                //     color: "orange"
              },
              {
                valuePath: "programName[1].percent",
                seriesDisplayName: "Early Childhood Family Education (ECFE)",
                //    color: "purple"
              },
              {
                valuePath: "programName[2].percent",
                seriesDisplayName: "Early Childhood Special Education (ECSE)",
                //    color: "green"
              },
              {
                valuePath: "programName[3].percent",
                seriesDisplayName: "MN District Preschool",
                //   color: "blue1"
              },
            ],
            errorConditions: [PluginPieces.standardErrorCondition],
          },
          {
            type: "template",
            dataSourceName: "data",
            dataSetPath: "dataSets.earlyEducationAndCareByYear",
            template: eecByYearTemplate,
            errorConditions: [PluginPieces.silentStandardErrorCondition],
          },
        ],
      },
      {
        title: "For More Information",
        visibleByDefault: true,
        openByDefault: false,
        views: [
          {
            type: "template",
            template:
              "<p>These charts shows public school kindergartners who participated in at least one of the following public early learning and development programs: Child Care Assistance (CCAP), Early Childhood Family Education (ECFE), Early Childhood Special Education (ECSE) or School District Preschool (MN District Preschool) prior to kindergarten entry. More information about the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=MDE034819&RevisionSelectionMethod=latestReleased&Rendition=primary'  target='_blank'>public programs included in ECLDS</a> is available.</p><p> Children attending private child care and early learning programs prior to kindergarten are not included in these counts. Not all children participating in these programs may have attended public kindergarten in Minnesota.</p><p>As of June 2021, Voluntary Prekindergarten (VPK) and School Readiness Plus (SRP) data are included in the MN District Preschool data provided by MDE. School Readiness data begin with the 2013-2014 school year; VPK data begin with the 2016-2017 school year; SRP data begin with the 2017-2018 school year.</p><h2> Glossary</h2><p><strong> CTSTR</strong>: Counts Too Small To Report - when results are less than 10.<br/><strong> ECE</strong>: Early Care and Education.<br/><strong>Kindergarten Cohort</strong>: A group of children who participated in public kindergarten in a given school year.<br/><strong> No Data Available</strong>: No data is available for the selected criteria.</p><h2>Selection Criteria Definitions</h2><p><strong> School County</strong>: County of the location of public school of enrollment. <br/><strong>School District</strong>: School district in the state of Minnesota.<br/><strong> School Year</strong>: Period of time that covers July 1 of one year through June 30 of the following.</p><p> For more information, open the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde034818&RevisionSelectionMethod=latestReleased&Rendition=primary'  target='_blank'>ECLDS Data Guide. </a></p>",
          },
        ],
      },
    ],

    filterSources: {
      orgs: {
        modelType: ECLDSModels.ECLDSOrgList,
        url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_orgid_parentdemographics.fex",
        //	noViewParams: true,
        enabled: true,
      },
      filters: {
        modelType: CardboardModels.FilterProducer,
        filterSources: ["filterForReport"],
        urls: {
            filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_programparticipation_EcoDevRegion.fex"
        },
        enabled: true,
        noViewParams: false
    },
      filters2: {
        url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_fiscal_year.fex",
        enabled: true,
        modelType: CardboardModels.FilterData,
      },
    },
    dataSources: {
      data: {
        modelType: CardboardModels.DocumentModel,
        // url: "/data/fakeDevEdData.json",
        // url: "/data/fakeDevEdDataFromRob.json",
        // url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_deveducation.fex&HSGRAD_ORGID=000101001&devEdCOHORTID=2008&RACE=_FOC_NULL&GENDER=_FOC_NULL&otherCRITERIA=_FOC_NULL",
        url: "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_programParticipation",
        yearPath: "meta.fiscalYear",

        enabled: true,
      },
    },
  };

  return exports;
});

